export default __webpack_public_path__ + "static/media/PRK.f334efe9.svg";